import Storage from "../../storage"

/**
 * All data related to the playback functionality.
 * 
 * @author Stan Hurks
 */
export default class StorageDataModelPlayback {

    /**
     * Whether or not to automatically play the video source
     */
    public autoplay: boolean = true

    /**
     * The volume of the player, use value `0` to mute.
     */
    public volume: number = 100

    /**
     * The forward duration for buffering
     */
    public forwardDuration: number = 20

    /**
     * Reset the data to defaults
     */
    public static reset = () => {
        const defaultInstance = new StorageDataModelPlayback()

        for (const property of Object.keys(defaultInstance)) {
            const value = (defaultInstance as any)[property] as any

            (Storage.data.playback as any)[property] = value
        }
    }
}